export default __webpack_public_path__ + "static/media/google-sheets-logo.6f908e12.svg";